module.exports = function() {
  return new Worker(__webpack_public_path__ + "e421bae466dbfefa2375.worker.js");
};